const __filename = "/app/views/layouts/application.js", __dirname = "/app/views/layouts";
import '/lib/common'
import '/lib/harley_event_store'
import Cookies from 'js-cookie'

import { HarleyEvent } from '/lib'
import StorageMonitor from '/lib/tracking'

document.addEventListener('DOMContentLoaded', () => {
  HarleyEvent.initialize()
})

/**
 * Set tracking cookies from URL parameters with 3-month expiry Can be called directly from HTML
 * templates or JavaScript.
 */
globalThis.setTrackingCookies = function () {
  if (!globalThis.trackingParameters || !Array.isArray(globalThis.trackingParameters)) {
    console.warn('trackingParameters not defined or not an array')
    return
  }

  // Get current URL parameters
  const urlParams = new URLSearchParams(globalThis.location.search)

  // Set cookie expiry to 3 months from now
  const expiryDate = new Date()
  expiryDate.setMonth(expiryDate.getMonth() + 3)

  // Check each parameter and set cookie if present
  globalThis.trackingParameters.forEach(param => {
    const value = urlParams.get(param)
    if (value) {
      Cookies.set(param, value, {
        expires: expiryDate,
        path: '/',
        sameSite: 'Lax'
      })
    }
  })
}

/** Clear all tracking cookies Can be called directly from HTML templates or JavaScript. */
globalThis.clearTrackingCookies = function () {
  if (!globalThis.trackingParameters || !Array.isArray(globalThis.trackingParameters)) {
    console.warn('trackingParameters not defined or not an array')
    return
  }

  globalThis.trackingParameters.forEach(param => {
    Cookies.remove(param, { path: '/' })
  })
}

// Parameters to manage
globalThis.trackingParameters = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'gclid',
  'fbclid',
  'referrer',
  'im_ref'
]

// if the consent settings are set, write them to local storage
if (localStorage.getItem('harleyCookieChoice_advertising_user_data') === 'true') {
  globalThis.setTrackingCookies()
}

// manage tracking based on consent settings
const monitor = new StorageMonitor('localStorage')

monitor.addListener('harleyCookieChoice_advertising_user_data', event => {
  if (event.newValue === 'true') {
    globalThis.setTrackingCookies()
  } else if (event.newValue === 'false') {
    globalThis.clearTrackingCookies()
  }
})
